import DragLayer from './DragLayer';

export default DragLayer;
